import SvgIcon from '@mui/material/SvgIcon';
import React, { memo } from 'react';

import { petrol } from '../../styles/mui/colors';

/**
 * @param {import('@mui/material/SvgIcon').SvgIconProps} props
 * @returns {React.JSX.Element}
 */
const IconCalenderComponent = ({ color = petrol.main, ...rest }) => {
  return (
    <SvgIcon sx={{ color }} {...rest} strokeWidth={1.5}>
      <path
        d="M6.75 3v2.25M17.25 3v2.25M3 18.75V7.5a2.25 2.25 0 0 1 2.25-2.25h13.5A2.25 2.25 0 0 1 21 7.5v11.25m-18 0A2.25 2.25 0 0 0 5.25 21h13.5A2.25 2.25 0 0 0 21 18.75m-18 0v-7.5A2.25 2.25 0 0 1 5.25 9h13.5A2.25 2.25 0 0 1 21 11.25v7.5"
        fill="none"
        stroke="currentColor"
      />
    </SvgIcon>
  );
};

IconCalenderComponent.displayName = 'IconCalender';

const IconCalendar = memo(IconCalenderComponent);

export default IconCalendar;
